import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface Props {
  setTab: (value: string) => void;
  tab: string;
  configArr: { tabName: string; tabKey: string }[];
}

export default function TableTabs({ setTab, tab, configArr }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div className="w-full lg:hidden">
        <FormControl className="lg:w-1/4" size="small" fullWidth>
          <Select
            sx={{ borderRadius: 25, width: '100%', backgroundColor: '#FFF' }}
            value={tab}
            onChange={event => navigate(`${location.pathname}?tab=${event.target.value}`)}
          >
            {configArr.map(it => {
              return (
                <MenuItem key={it.tabKey} value={it.tabKey}>
                  {t(it.tabName)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>

      <div className="my-[15px] hidden items-center lg:flex">
        {configArr.map(it => {
          return (
            <div
              key={it.tabKey}
              onClick={() => navigate(`${location.pathname}?tab=${it.tabKey}`)}
              className={`cursor-pointer text-[32px] font-bold ${tab === it.tabKey ? 'border-b-2 text-[#242C2C]' : 'text-[#656D7B]'} border-[#52C7FA] px-3`}
            >
              {t(it.tabName)}
            </div>
          );
        })}
      </div>
    </>
  );
}
